<template>
  <div id="news">
    <div class="container pb100">
      <p class="text-center font20 mt50">{{ post.title }}</p>
      <p class="text-center font16 text-uppercase gray">{{ post.tag }}</p>
      <a href="#/news/" class="font16 backto hidden-xs">
        <i class="iconfont3 icon-back"></i> BACK TO NEWS
      </a>

      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="new-content">
            <img :src="$store.state.serverURL + '/' + post.file_name" alt="">
          </div>
          <div class="new-content" v-html="post.content">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/news.css";
export default {
  name: "post",
  props: {
    post: Object
  }
};
</script>
